<template>
  <li class="int_pro_list_li" @click="goItemView(item)">
    <div class="top">
      <div class="list_logo" v-if="!isProductPage">
        <img
          :src="
            require(`@/assets/front/images/v2/logos/${getLogo(item.telecomId)}`)
          "
        />
      </div>
      <div class="list_num" v-else>{{ isNum }}<span>위</span></div>
      <div class="right">
        <ul>
          <li class="place" v-if="item.setArea">
            <p>{{ item.setArea }}</p>
          </li>
          <li class="bar" v-if="item.setArea"><p>ㅣ</p></li>
          <li v-if="item.internetSpeed">
            <p>{{ isInternetSpeed(item.internetSpeed) }}</p>
          </li>
          <li class="bar" v-if="item.channelCount"><p>ㅣ</p></li>
          <li v-if="item.channelCount">
            <p>{{ item.channelCount }}ch</p>
          </li>
        </ul>
        <button
          class="ic_like right_like"
          :class="`${isBookmark === 'Y' ? 'on' : ''}`"
          @click.stop="toggleBookmark"
          v-if="!isMyPage && !isProductPage"
        ></button>
      </div>
    </div>
    <div class="mid">
      <ul>
        <li v-if="item.internetId || item.wifiId">
          <p>
            {{ item.internetName
            }}{{ item.internetId && item.wifiId ? ` + ${item.wifiName}` : '' }}
          </p>
        </li>
        <li class="tv" v-if="item.tvId || item.settopId">
          <p>
            {{ item.tvName
            }}{{ item.tvId && item.settopId ? `+${item.settopName}` : '' }}
          </p>
        </li>
      </ul>
    </div>
    <div class="btm">
      <div class="person_num">
        <p>
          <span>{{ item.viewCount }}</span
          >명이 선택!
        </p>
      </div>
      <div class="price">
        <p class="real">{{ formatNumber(item.totalPrice) }}원</p>
        <div class="discont">
          <div class="days"><P>3년 약정</P></div>
          <h4>
            월 <span>{{ formatNumber(item.realPrice) }}</span
            >원
          </h4>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
import { mapActions as internetMapActions } from '@common/store/modules/internet';
import * as internetTypes from '@common/store/modules/internet/types';

import { toCurrency } from '@common/lib/common/utils.js';

export default {
  name: 'InternetProduct',
  description: '사용자 메인 - 나에게 맞는 인터넷 ITEM',
  props: {
    item: Object,
    isMyPage: {
      type: Boolean,
      default: false,
    },
    isProductPage: {
      type: Boolean,
      default: false,
    },
    isNum: Number,
  },
  data(props) {
    return {
      isBookmark: props.item.isBookmark,
      telecomLogo: [
        { telecomId: 'SKT', logoImg: 'logo_skt_round.svg' },
        { telecomId: 'KT', logoImg: 'logo_kt_round.svg' },
        { telecomId: 'LGUPLUS', logoImg: 'logo_lgu_round.svg' },
        { telecomId: 'HELLO', logoImg: 'logo_hello_list.png' },
        { telecomId: 'SKB', logoImg: 'logo_skb_list.png' },
        { telecomId: 'SKYLIFE', logoImg: 'logo_skylife_list.png' },
      ],
    };
  },
  methods: {
    ...internetMapActions([internetTypes.UPDATE_INTERNET_BOOKMARK]),
    goItemView(item) {
      this.$emit('view', item);
    },
    toggleBookmark() {
      if (this.isBookmark === 'Y') {
        this.isBookmark = 'N';
      } else {
        this.isBookmark = 'Y';
      }
      this.setBookmark();
    },
    setBookmark() {
      let params = { ...this.item };
      params.procType = this.isBookmark === 'Y' ? 'ON' : 'OFF';
      this[internetTypes.UPDATE_INTERNET_BOOKMARK](params);
      this.item.isBookmark = this.isBookmark;
    },
    isInternetSpeed(internetSpeed) {
      if (internetSpeed >= 1000) {
        let internetSpeedFormat = internetSpeed / 1000;

        return internetSpeedFormat + 'G';
      } else {
        return internetSpeed + 'M';
      }
    },
    formatNumber(val) {
      return toCurrency(val);
    },
    isWeekCost(id, cost, weekendCost) {
      let value = false;
      if ((id === 'KT' || id === 'SKYLIFE') && cost !== weekendCost) {
        value = true;
      }
      return value;
    },
    getLogo(telecomId) {
      const foundInfo = this.telecomLogo.find(
        info => info.telecomId === telecomId,
      );

      return foundInfo.logoImg;
    },
  },
};
</script>
